import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";

const myTheme = createMuiTheme({
  overrides: {
    MuiButton: {
      root: {
        textTransform: "none",
        margin: "8px",
      },
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={myTheme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// Service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
